// Contains imports that are necessary for the functioning of the 3d tools
// Must be imported once per App

import earcut from 'earcut';
// BabylonJS needs earcut to be available in the global window object.
if (window && !window.earcut) {
    window.earcut = earcut;
}
